import { useMutation, useQuery } from "@tanstack/react-query";
import { getAgingReportEnquiry } from "services/data.report.service";
import { TableCard } from "ui-components/Layout";
import { ListLayout } from "ui-components/Layout";
import BasicTable from "ui-components/tables/BasicTable";
import { AgingReportEnquiryColumns } from "./columns";
import { useState } from "react";
import { useCustomerValue } from "providers/CustomerContext";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { CSVLink } from "react-csv";
import { Texts } from "ui-components/Form";
import { Grid } from "@mui/material";
import { scan } from "services/data.test.service";
import { scanDelete } from "services/data.test.service";
import { scanGet } from "services/data.test.service";
import { scanConfirm } from "services/data.test.service";
import { useTeamValue } from "providers/TeamContext";
import { Success, Error } from "ui-components/Alert";
import { EmailButton } from "ui-components/Button";
import { ExportButton } from "ui-components/Button";
import { getCustomerOptions } from "services/data.internal.service";
import { SelectFields } from "ui-components/Form";
import { LoadingDialog } from "ui-components/Alert";
import { ExportDialog } from "ui-components/Alert";
import useCsvDownloadHook from "hooks/useCsvDownloadHook";
import dayjs from "dayjs";

function AgingReportEnquiry() {
  const { permissions, allowAll } = useTeamValue();
  const { customerCode, customerOpt } = useCustomerValue();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const exportPermission =
    allowAll ||
    (Boolean(permissions["Aging_Report"]) &&
      permissions["Aging_Report"].findIndex((b) => b === "export") !== -1);
  const { downloadCsv, isDownloading } = useCsvDownloadHook();

  const [customers, setCustomers] = useState([]);

  const [customerOptions, setCustomerOptions] = useState([]);

  useQuery({
    queryKey: ["customer-options", { customerCode }],
    queryFn: () => getCustomerOptions(),
    onSuccess: (data) => {
      const activeCust = customerOpt.filter(x => data.data.some(y => y === x));
      setCustomerOptions(activeCust);
      setCustomers([customerCode])
    },
    onError: () => { },
  })

  const { refetch, isFetching } = useQuery({
    queryKey: ["aging-report-enquiry", { customers }],
    queryFn: () => getAgingReportEnquiry({ customerCode, customers }),
    enabled: Boolean(customerCode) && Boolean(customers.length),
    onSuccess: (data) => {
      setData(data.data.data);
      setFilteredData(data.data.data);
    },
    onError: () => { },
  });

  const headers = [
    { label: "Customer Code", key: "customerCode" },
    { label: "Vendor Code", key: "vendorCode" },
    { label: "Category", key: "skuCategory" },
    { label: "SKU Code", key: "skuCode" },
    { label: "SKU Descriptions", key: "skuDescriptions" },
    { label: "Pack Type", key: "packType" },
    { label: "Base UOM", key: "baseUOM" },
    { label: "PO Number", key: "poNumber" },
    { label: "ASN Number", key: "asnNumber" },
    { label: "GRN No", key: "grnNo" },
    { label: "Date Received", key: "dateReceived" },
    { label: "Warehouse Code", key: "warehouseCode" },
    { label: "Zone ID", key: "zoneID" },
    { label: "Location ID", key: "locationID" },
    { label: "Pallet Number", key: "palletNbr" },
    { label: "<0 days", key: "dateRange1" },
    { label: "0 - 30 days", key: "dateRange2" },
    { label: "31 - 60 days", key: "dateRange3" },
    { label: "61 - 90 days", key: "dateRange4" },
    { label: "91 - 120 days", key: "dateRange5" },
    { label: "121 - 150 days", key: "dateRange6" },
    { label: "151 - 180 days", key: "dateRange7" },
    { label: ">180 days", key: "dateRange8" },
    { label: "Allocated Qty", key: "allocatedQty" },
    { label: "Balance Qty", key: "balanceQty" },
  ];

  const handleFilterRowsChange = (filteredData) => {
    setFilteredData(filteredData);
  };

  const onSuccess = (data) => {
    setAlert(<Success data={data} onChange={setAlert} />);
  };
  const onError = (data) => {
    setAlert(<Error data={data} onChange={setAlert} />);
  };

  return (
    <ListLayout>
      {isFetching && <LoadingDialog />}
      {isDownloading && <ExportDialog />}
      <TableCard sx={{ my: 3 }}>
        <MDBox display="flex" justifyContent="flex-end" margin="10px">
          <Grid container spacing={3}>
            <Grid item xs={3}>
              {(Boolean(customerOptions) && Boolean(customerOptions.length)) && (
                <SelectFields
                  field={{
                    name: "",
                    label: "Customers",
                    value: customers,
                    errors: {},
                    multiple: true,
                  }}
                  options={customerOptions}
                  onChange={(e, v) => setCustomers(v)}
                />
              )}
            </Grid>
            <Grid item xs={4}>
              <MDButton
                variant="gradient"
                color="info"
                disabled={!exportPermission}
                onClick={() => {
                  const filename = `${customers.join(', ')}_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_AgingReport`;
                  downloadCsv(filename, filteredData, headers)
                }}
              >
                export
              </MDButton>
            </Grid>
            {/* <Grid item xs={4}> */}
            {/* <Grid item xs={1.5}>
              <MDButton variant="gradient" color="info" disabled={!exportPermission}>
                <CSVLink
                  style={{ color: "white" }}
                  filename={`Aging_Report`}
                  headers={headers}
                  data={filteredData}
                >
                  export
                </CSVLink>
              </MDButton> */}
            {/* <ExportButton
                  filename={`Aging_Report`}
                  headers={headers}
                  fileData={filteredData}
                  disabled={!exportPermission}
              /> */}
            {/* </Grid> */}
            <Grid item xs={5}>
              <EmailButton
                filename={`${customers.join(', ')}_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_AgingReport`}
                fileData={filteredData}
                headers={headers}
                onSuccess={onSuccess}
                onError={onError}
                customerCode={customerCode}
              />
            </Grid>
          </Grid>
        </MDBox>
        <BasicTable
          data={data}
          columns={AgingReportEnquiryColumns}
          onFilterRowsChange={handleFilterRowsChange}
        />
      </TableCard>
    </ListLayout>
  );
}

export default AgingReportEnquiry;
